export { CieComponent } from './cie/cie.component';
export { PatientsByDoctorComponent } from './patients-by-doctor/patients-by-doctor.component';
